import { ICreatedUpdatedBy } from '@/bundles/App/interfaces/ICreatedUpdatedBy';
import { IPermissions } from '@/bundles/App/interfaces/IPermissions';
import { Nullable } from '@/utils/types';

// ids arrive both raw (123) and prefixed ('Member/123') depending on the endpoint
const normalizeMemberId = (id?: Nullable<string | number>): string => {
  return id === undefined || id === null ? '' : String(id).replace('Member/', '');
};

export const getPrivacyOwner = (permissions?: Nullable<IPermissions>, created?: Nullable<ICreatedUpdatedBy>): Nullable<ICreatedUpdatedBy> => {
  if (permissions && permissions.set_by) {
    return permissions.set_by;
  }
  return created || null;
};

export const isOwnedByMember = (owner: Nullable<ICreatedUpdatedBy>, memberId?: Nullable<string | number>): boolean => {
  if (!owner) {
    return false;
  }

  const ownerId = normalizeMemberId(owner._id !== undefined && owner._id !== null ? owner._id : owner.id);
  const userId = normalizeMemberId(memberId);

  return Boolean(ownerId && userId && ownerId === userId);
};

export const getPrivateToLabel = (
  permissions?: Nullable<IPermissions>,
  created?: Nullable<ICreatedUpdatedBy>,
  currentUserId?: Nullable<string | number>,
): string => {
  const owner = getPrivacyOwner(permissions, created);

  if (!owner || !owner.name || isOwnedByMember(owner, currentUserId)) {
    return 'Private to Me';
  }

  return `Private to ${owner.name}`;
};
